import { render } from "./InternalKpiDashboard.vue?vue&type=template&id=4197f326"
import script from "./InternalKpiDashboard.vue?vue&type=script&lang=js"
export * from "./InternalKpiDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__